
import mixins from "vue-typed-mixins";
import CustomValidation from "../mixins/CustomValidation";
import Common from "../mixins/Common";
import Sidebar from "primevue/sidebar";
import Password from "primevue/password";
import LottieAnimation from "@/components/LottieAnimationsComponent.vue";
import { mapMutations, mapGetters } from "vuex";
import { MarketplaceEstimatesViewModel } from "../interfaces/MarketplaceEstimatesViewModel";
import { PatientRegisterViewModel } from "@/interfaces/PatientRegisterViewModel";
import { object, string, boolean, number, date } from "yup";
import swal from "sweetalert";
import { AjaxReturnViewModel } from "@/interfaces/AjaxReturnViewModel";
import { PatientViewModel } from "@/interfaces/PatientViewModel";
import store from "@/store/index";
import { VueTelInput } from "vue-tel-input";
import moment from "moment";
import router from "@/router";
import { PatientPortalMedicationMarketplaceRx } from "@/interfaces/PatientPortalMedicationMarketplaceRx";

enum rxReceivedScreenView {
  cart = 0,
  shipping = 1,
  payment = 2,
  success = 3,
}
enum rxEstimateScreenView {
  cart = 0,
  signup = 1,
  basicinfo = 2,
}

export default mixins(CustomValidation, Common).extend({
  props: {
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      rxReceivedView: rxReceivedScreenView.cart,
      rxEstimateView: rxEstimateScreenView.cart,
      ifAllergiesExist: false as boolean,
      isLoading: false as boolean,
      isLoadingSMS: false as boolean,
      transitionName: "slide-left" as string,
      medicationChoices: [] as MarketplaceEstimatesViewModel[],
      confirmPassword: "" as string,
      match: false,
      firstName: "" as string,
      lastName: "" as string,
      email: "" as string,
      password: "" as string,
      isPasswordShow: false as boolean,
      eightChars: false,
      oneNumber: false,
      lowerCase: false,
      upperCase: false,
      isConfirmPasswordVisible: false as boolean,
      enableSubmit: false,
      iAgree: false,
      signUpSchema: object().shape({
        password: string().typeError("Password is required.").required("Password is required."),
        confirmPassword: string().typeError("Password is required.").required("Password is required."),
        firstName: string().typeError("First Name is required.").required("First Name is required."),
        lastName: string().typeError("Last Name is required.").required("Last Name is required."),
        email: string().typeError("Email is required.").email("The Email field is not a valid e-mail address.").required("Email is required"),
        iAgree: boolean().typeError("You must agree to the terms of use privacy policy and consent to remote health.").oneOf([true], "You must agree to the terms of use privacy policy and consent to remote health.").required("You must agree to the terms of use privacy policy and consent to remote health."),
      }),
      gender: null as string | null,
      dobMonth: null as string | null,
      dobDay: null as string | null,
      dobYear: null as string | null,
      phone: "" as string,
      basicInfoSchema: object().shape({
        gender: string().typeError("Gender is required.").required(),
        dobMonth: number().integer().typeError("Invalid Month.").min(0, "Invalid Month.").max(12, "Invalid Month.").required(),
        dobDay: number().integer().typeError("Invalid Day.").min(0, "Invalid Day.").max(31, "Invalid Day.").required(),
        dobYear: number().integer().typeError("Invalid Year.").min(1900, "Invalid Year.").max(3000, "Invalid Year.").required(),
        dateOfBirthValidation: date().typeError("Invalid Birthdate.").required(),
        phone: string()
          .typeError("Phone Number is required.")
          .matches(/^\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})$/, "Invalid Phone Number.")
          .required("Phone Number is required."),
      }),
      currentSMSStep: 1 as number,
      firstdigit: "" as string | "",
      seconddigit: "" as string | "",
      thirddigit: "" as string | "",
      fourthdigit: "" as string | "",
      fifthdigit: "" as string | "",
      sixthdigit: "" as string | "",
      invalidCode: false as boolean,
      newCodeSent: false as boolean,
      defaultErrorMessage: false as boolean,
      formattedPhone: "" as string,
      phoneIsValid: false as boolean,
      patientData: null as PatientViewModel | null,
      marketplaceRxs: [] as PatientPortalMedicationMarketplaceRx[],
    };
  },
  computed: {
    ...mapGetters({
      ShowPharmacyCart: "getShowPharmacyCart",
      MarketplaceEstimates: "getMarketplaceEstimates",
      SignedIn: "getSignedIn",
      Content: "getContent",
      Affiliate: "getAffiliate",
      MarketplaceRxs: "getMarketplaceRxs",
    }),
    dateOfBirthValidation(): Date | null {
      if (this.dobMonth !== null && this.dobDay !== null && this.dobYear !== null) {
        return moment(this.dateOfBirth, "YYYY-MM-DD").toDate();
      }
      return null;
    },
    dateOfBirth(): string | null {
      if (this.dobMonth !== null && this.dobDay !== null && this.dobYear !== null) {
        return this.dobYear + "-" + this.dobMonth + "-" + this.dobDay;
      }
      return null;
    },

    totalPrice(): number {
      return this.MarketplaceRxs.reduce((sum, rx) => sum + rx.programPrice, 0);
    },
  },
  watch: {
    password: function () {
      this.validatePassword();
    },
    confirmPassword: function () {
      this.validatePassword();
    },
    rxEstimateView(newVal) {
      if (this.type === "rxEstimate" && newVal === 1) {
        this.setupValidation(this.signUpSchema);
      }
      if (this.type === "rxEstimate" && newVal === 2) {
        this.setupValidation(this.basicInfoSchema);
      }
    },
  },
  created() {
    // Initialize data from the Vuex store
    if (this.type === "rxEstimate") {
      this.medicationChoices = this.MarketplaceEstimates;
    } else if (this.type === "rxReceived") {
      this.marketplaceRxs = this.MarketplaceRxs;
    }
  },
  mounted() {
    window.onmessage = (e) => {
      if (!e.data || !e.data.messageType) return;
      switch (e.data.messageType) {
        case "UpdatePhoneNumber":
          this.closeSMSModal;
          break;
        case "ToggleSMS":
          this.toggleSMS(e.data.toggleSMSValue);
          break;
        default:
          break;
      }
    };
  },
  methods: {
    ...mapMutations({
      setShowPharmacyCart: "setShowPharmacyCart",
      setMarketplaceEstimates: "setMarketplaceEstimates",
      setLoading: "setLoading",
      setMarketplaceRxs: "setMarketplaceRxs",
    }),
    nextStep() {
      this.transitionName = "slide-left";
      this.isLoading = true;

      setTimeout(() => {
        if (this.type === "rxReceived") {
          this.rxReceivedView++;
        }
        if (this.type === "rxEstimate") {
          this.rxEstimateView++;
        }

        this.isLoading = false;
      }, 2000);
    },
    backToCart() {
      this.transitionName = "slide-right";
      this.rxReceivedView = 0;
    },
    backToAddress() {
      this.transitionName = "slide-right";
      this.rxReceivedView = 1;
    },
    closeCart() {
      this.setShowPharmacyCart({ show: false, type: "" });
    },
    async removeMedication(index: any) {
      // Capture the medication being removed
      const removedMedication = { ...this.medicationChoices[index], active: false };

      // Remove the medication from the array
      this.medicationChoices.splice(index, 1);

      // Update estimates with the modified array
      this.setMarketplaceEstimates(this.medicationChoices);

      if (this.SignedIn) {
        // Send the removed medication with `active` set to false
        const payload = Array.isArray(removedMedication) ? removedMedication : [removedMedication];

        await this.$store.dispatch("UpdateMarketplaceEstimates", payload);
      }
    },

    removeMarketplaceRx(index: any) {
      this.marketplaceRxs.splice(index, 1);
      this.setMarketplaceRxs(this.marketplaceRxs);
    },
    openAllergyModal() {
      this.$bvModal.show("modal-allergy");
    },
    hideSidebar() {
      this.setShowPharmacyCart({ show: false, type: "" });
    },

    // Sign Up Screen
    async signUp() {
      this.isLoading = true;
      if (this.$gtm && this.$gtm.enabled() && this.Content.GTMConfig) {
        window.dataLayer?.push({
          event: "signup",
          email: this.email,
          firstName: this.firstName,
          lastName: this.lastName,
        });
      }
      this.errors = [];
      this.schema
        .validate(this, { abortEarly: false })
        .then(async () => {
          this.errors = [];
          let prVM: PatientRegisterViewModel = { questionnaireTypeID: 0, iAgree: false, captchaToken: null, email: this.email, firstName: this.firstName, lastName: this.lastName, password: this.password, promoCode: null };
          let pVM = (await this.$store.dispatch("PatientRegister", prVM)) as AjaxReturnViewModel<PatientViewModel>;
          if (!pVM || !pVM.success) {
            this.isLoading = false;
            swal("Error", "Error creating user. If you already have an account a password reset email has been sent. If not, please try again.");
            return;
          }
          this.patientData = pVM.data;

          var signedIn = await this.$store.dispatch("SignIn", { u: prVM.email, p: prVM.password });
          if (!signedIn) {
            this.isLoading = false;
            swal("Error", "Error signing in. If you already have an account a password reset email has been sent. If not, please try again.");
            return;
          }
          if (this.MarketplaceEstimates) {
            await this.$store.dispatch("UpdateMarketplaceEstimates", this.MarketplaceEstimates);
          }
          this.nextStep();
        })
        .catch((err: { inner: any[] }) => {
          this.isLoading = false;
          err.inner.forEach((error: { path: string; message: string }): void => {
            this.errors.push({ key: error.path, value: error.message });
          });
        });
    },
    validatePassword: function () {
      this.enableSubmit = false;

      if (this.password && this.password.length > 7) {
        this.eightChars = true;
      } else {
        this.eightChars = false;
      }
      var rgxON = RegExp("[0-9]");
      if (this.password && rgxON.test(this.password)) {
        this.oneNumber = true;
      } else {
        this.oneNumber = false;
      }
      var lcRGX = RegExp("[a-z]");
      if (this.password && lcRGX.test(this.password)) {
        this.lowerCase = true;
      } else {
        this.lowerCase = false;
      }
      var ucRGX = RegExp("[A-Z]");
      if (this.password && ucRGX.test(this.password)) {
        this.upperCase = true;
      } else {
        this.upperCase = false;
      }
      if (this.isConfirmPasswordVisible) {
        if (this.password && this.confirmPassword && this.password == this.confirmPassword) {
          this.match = true;
        } else {
          this.match = false;
        }
      } else if (!this.isConfirmPasswordVisible && this.password) {
        this.match = true;
        this.confirmPassword = this.password;
      } else {
        this.match = false;
      }
      if (this.eightChars && this.oneNumber && this.lowerCase && this.upperCase && this.match) {
        this.enableSubmit = true;
      }
      console.log("match:", this.match);
    },
    togglePassword() {
      this.isPasswordShow = !this.isPasswordShow;
    },

    // Basic Info Screen
    async basicInfo() {
      this.isLoading = true;
      this.errors = [];
      this.schema
        .validate(this, { abortEarly: false })
        .then(async () => {
          if (this.$gtm && this.$gtm.enabled() && this.Content.GTMConfig) {
            window.dataLayer?.push({
              event: "basicinfo",
              phone: this.phone,
            });
          }
          this.errors = [];

          if (this.patientData) {
            this.patientData.dateOfBirth = this.dateOfBirth;
            this.patientData.gender = this.gender;
            this.patientData.phone = this.phone;
          }

          await store.dispatch("SavePatient", { p: this.patientData });

          if (this.Affiliate.smsEnabled === true) {
            this.showSMSVerifyModal();

            await store.dispatch("GetSMSCode", { phone: this.phone });
            this.invalidCode = false;
            this.newCodeSent = false;
            this.defaultErrorMessage = false;

            return;
          }

          this.setShowPharmacyCart({ show: false, type: "" });

          router.push("/patientportal");
        })
        .catch((err: { inner: any[] }) => {
          this.isLoading = false;
          err.inner.forEach((error: { path: string; message: string }): void => {
            this.errors.push({ key: error.path, value: error.message });
          });
        });
    },
    dobDay_onKeyUp() {
      if (this.dobDay !== null && this.dobDay.length === 2) {
        (this.$refs.dobYear as HTMLElement).focus();
      }
    },
    dobMonth_onKeyUp() {
      if (this.dobMonth !== null && this.dobMonth.length === 2) {
        (this.$refs.dobDay as HTMLElement).focus();
      }
    },
    inputChange(e: Event) {
      e.preventDefault();
      const keys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
      const bspace = e.keyCode == 8 ? true : false;
      let validkey = true;
      if (!keys.includes(e.key) && e.keyCode != 8) {
        validkey = false;
      }
      var current = null;
      var target = null;
      switch (e.target) {
        case this.$refs.firstd:
          if (!bspace) {
            target = this.$refs.secondd;
          }
          current = this.$refs.firstd;
          break;
        case this.$refs.secondd:
          if (!bspace) {
            target = this.$refs.thirdd;
          } else {
            target = this.$refs.firstd;
          }
          current = this.$refs.secondd;
          break;
        case this.$refs.thirdd:
          if (!bspace) {
            target = this.$refs.fourthd;
          } else {
            target = this.$refs.secondd;
          }
          current = this.$refs.thirdd;
          break;
        case this.$refs.fourthd:
          if (!bspace) {
            target = this.$refs.fifthd;
          } else {
            target = this.$refs.thirdd;
          }
          current = this.$refs.fourthd;
          break;
        case this.$refs.fifthd:
          if (!bspace) {
            target = this.$refs.sixthd;
          } else {
            target = this.$refs.fourthd;
          }
          current = this.$refs.fifthd;
          break;
        case this.$refs.sixthd:
          if (bspace) {
            target = this.$refs.fifthd;
          }
          current = this.$refs.sixthd;
          break;
        default:
          break;
      }
      if (target && validkey && !bspace) {
        target.focus();
        target.select();
        return;
      }
      if (e.key == " " && current && !bspace) {
        current.value = "";
      }
      if (current && target && bspace && current.value == "") {
        target.focus();
        target.select();
      }
      const code = this.calcCode();
      if (code.length == 6) {
        this.$emit("codeChange", code);
      }
    },
    inputPaste(e: Event) {
      e.preventDefault();
      const data = e.clipboardData.getData("text");
      if (data.length == 6) {
        this.firstdigit = data[0];
        this.seconddigit = data[1];
        this.thirddigit = data[2];
        this.fourthdigit = data[3];
        this.fifthdigit = data[4];
        this.sixthdigit = data[5];

        const code = this.calcCode();
        this.$emit("codeChange", code);
      }
    },
    calcCode() {
      return this.firstdigit + this.seconddigit + this.thirddigit + this.fourthdigit + this.fifthdigit + this.sixthdigit;
    },
    async toggleSMS(option: boolean) {
      this.setLoading(true);
      await store.dispatch("ToggleSMS", { enabled: option });
      this.closeSMSModal;
      this.setShowPharmacyCart({ show: false, type: "" });
      router.push("/patientportal");
    },
    async displayNextSMSStep() {
      if (!this.firstdigit || !this.seconddigit || !this.thirddigit || !this.fourthdigit || !this.fifthdigit || !this.sixthdigit) {
        this.invalidCode = true;
        return;
      } else {
        try {
          this.isLoadingSMS = true;
          const response = await store.dispatch("ValidateSMSCode", { code: this.calcCode() });

          if (response && response.success === true) {
            this.currentSMSStep++;
            setTimeout(() => {
              this.currentSMSStep = 3;
            }, 2500);
            this.isLoadingSMS = false;
          } else {
            this.invalidCode = true;
            this.newCodeSent = false;
            this.isLoadingSMS = false;
          }
        } catch (error) {
          console.error("Error validating SMS code: ", error);
          this.invalidCode = true; // Handle unexpected errors by setting invalidCode to true
          this.isLoadingSMS = false;
        }
      }
    },
    async resendCode() {
      try {
        this.setLoading(true);
        const response = await store.dispatch("GetSMSCode", { phone: this.phone });

        if (response && response.success === true) {
          this.invalidCode = false;
          this.newCodeSent = true;
          this.setLoading(false);
        } else {
          this.defaultErrorMessage = true;
          this.setLoading(false);
        }
      } catch (error) {
        console.error("Error sending SMS code: ", error);
        this.defaultErrorMessage = true;
      }
    },
    closeSMSModal() {
      this.isLoading = false;
      const input = document.querySelector(".vti__input") as HTMLElement;

      this.$bvModal.hide("modal-sms");
      setTimeout(() => {
        if (input) {
          input.focus();
        }
      }, 1000);
    },
    showSMSVerifyModal() {
      this.formatPhoneNumber(this.phone);
      this.$bvModal.show("modal-sms");
    },
    formatPhoneNumber(phone: string) {
      const cleaned = phone.replace(/\D/g, "");

      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

      if (match) {
        this.formattedPhone = `(${match[1]}) ${match[2]}-${match[3]}`;
      } else {
        return phone;
      }
    },
    phone_validate(e: { isValid: any }) {
      this.phoneIsValid = e.isValid;
    },
  },
  components: {
    Sidebar,
    LottieAnimation,
    Password,
    VueTelInput,
  },
});
